export const translationsExtra = {
    playNow: {
        en: "Play Now",
        am: "አሁን ጫወት",
        fr: "Lire Maintenant",
        ar: "تشغيل الآن",
        es: "Reproducir Ahora",
        "zh-CN": "立即播放",
        hi: "अभी चलाएं"
    },
    edit: {
        en: "Edit",
        am: "አርትዕ",
        fr: "Modifier",
        ar: "تعديل",
        es: "Editar",
        "zh-CN": "编辑",
        hi: "संपादित करें"
    },
    unknownVenue: {
        en: "Unknown Venue",
        am: "ያልታወቀ ቦታ",
        fr: "Lieu Inconnu",
        ar: "مكان غير معروف",
        es: "Lugar Desconocido",
        "zh-CN": "未知地点",
        hi: "अज्ञात स्थल"
    },
    likes: {
        en: "Likes",
        am: "ውድድሮች",
        fr: "J'aime",
        ar: "إعجابات",
        es: "Me gusta",
        "zh-CN": "点赞",
        hi: "पसंद"
    },
    ratings: {
        en: "Ratings",
        am: "ደረጃዎች",
        fr: "Évaluations",
        ar: "تقييمات",
        es: "Calificaciones",
        "zh-CN": "评分",
        hi: "रेटिंग्स"
    },
    searchPlaylists: {
        en: "Search playlists...",
        am: "ዝርዝሮችን ፈልግ...",
        fr: "Rechercher des playlists...",
        ar: "ابحث في القوائم...",
        es: "Buscar playlists...",
        "zh-CN": "搜索播放列表...",
        hi: "प्लेलिस्ट खोजें..."
    },
    myPlaylists: {
        en: "My Playlists",
        am: "የእኔ ዝርዝሮች",
        fr: "Mes Playlists",
        ar: "قوائمي",
        es: "Mis Playlists",
        "zh-CN": "我的播放列表",
        hi: "मेरी प्लेलिस्ट"
    },
    tapHere: {
        en: "Tap Here",
        am: "እዚህ መጫን",
        fr: "Appuyez ici",
        ar: "اضغط هنا",
        es: "Toca aquí",
        "zh-CN": "点击这里",
        hi: "यहाँ टैप करें"
    },
    votes: {
        en: "VOTES",
        am: "ተምሳሌቶች",
        fr: "VOTES",
        ar: "الأصوات",
        es: "VOTOS",
        "zh-CN": "投票",
        hi: "वोट्स"
    },

    total: {
        en: "total",
        am: "ጠቅላላ",
        fr: "total",
        ar: "الإجمالي",
        es: "total",
        "zh-CN": "总数",
        hi: "कुल"
    },
    search: {
        en: "Search playlists...",
        am: "ፕሌሊስቶችን ፈልግ...",
        fr: "Rechercher des playlists...",
        ar: "ابحث عن القوائم...",
        es: "Buscar listas de reproducción...",
        "zh-CN": "搜索播放列表...",
        hi: "प्लेलिस्ट खोजें..."
    },
    "Related Search": {
        en: "Related Search",
        am: "ተዛማጅ ፍለጋ",
        fr: "Recherche Connexe",
        ar: "بحث ذو صلة",
        es: "Búsqueda Relacionada",
        "zh-CN": "相关搜索",
        hi: "संबंधित खोज"
    },

    nowPlaying: {
        en: "Now Playing",
        am: "አሁን የሚጫወተው",
        fr: "Lecture en cours",
        ar: "يتم التشغيل الآن",
        es: "Reproduciendo ahora",
        "zh-CN": "正在播放",
        hi: "अब चल रहा है"
    },
    addToQueue: {
        en: "Add to Queue",
        am: "ወደ ተራ አክል",
        fr: "Ajouter à la file",
        ar: "أضف إلى القائمة",
        es: "Agregar a la cola",
        "zh-CN": "加入队列",
        hi: "कतार में जोड़ें"
    },
    recentSearches: {
        en: "Recent Searches",
        am: "የቅርብ ጊዜ ፍለጋዎች",
        fr: "Recherches récentes",
        ar: "عمليات البحث الأخيرة",
        es: "Búsquedas recientes",
        "zh-CN": "最近搜索",
        hi: "हाल की खोजें"
    },
    clear: {
        en: "Clear",
        am: "አጥፋ",
        fr: "Effacer",
        ar: "مسح",
        es: "Borrar",
        "zh-CN": "清除",
        hi: "साफ़ करें"
    },
    searching: {
        en: "Searching...",
        am: "በመፈለግ ላይ...",
        fr: "Recherche...",
        ar: "يتم البحث...",
        es: "Buscando...",
        "zh-CN": "搜索中...",
        hi: "खोज रहे हैं..."
    },
    "No Playlists Found": {
        en: "No playlists found",
        am: "ምንም የተፈጠረ ዝርዝር አልተገኘም",
        fr: "Aucune playlist trouvée",
        ar: "لم يتم العثور على أي قائمة تشغيل",
        es: "No se encontraron listas de reproducción",
        "zh-CN": "未找到播放列表",
        hi: "कोई प्लेलिस्ट नहीं मिली"
    },
    allowGuestAdd: {
        en: "Allow guests to add songs",
        am: "እንግዶች ዘፈኖችን እንዲጨምሩ ፍቀድ",
        fr: "Autoriser les invités à ajouter des chansons",
        ar: "السماح للضيوف بإضافة الأغاني",
        es: "Permitir a invitados agregar canciones",
        "zh-CN": "允许访客添加歌曲",
        hi: "मेहमानों को गाने जोड़ने दें"
    },
    allowed: {
        en: "Allowed",
        am: "የተፈቀደው",
        fr: "Autorisé",
        ar: "مسموح",
        es: "Permitido",
        "zh-CN": "允许",
        hi: "अनुमत"
    },
    notAllowed: {
        en: "Not Allowed",
        am: "የተከለከለው",
        fr: "Non autorisé",
        ar: "غير مسموح",
        es: "No permitido",
        "zh-CN": "不允许",
        hi: "निषिद्ध"
    },
    on: {
        en: "On",
        am: "ነው",
        fr: "Activé",
        ar: "تشغيل",
        es: "Activado",
        "zh-CN": "开启",
        hi: "चालू"
    },
    off: {
        en: "Off",
        am: "የተዘጋ",
        fr: "Désactivé",
        ar: "إيقاف",
        es: "Desactivado",
        "zh-CN": "关闭",
        hi: "बंद"
    },
    noPlaylistsFound: {
        en: "No playlists found",
        am: "ምንም ዝርዝር አልተገኘም",
        fr: "Aucune playlist trouvée",
        ar: "لم يتم العثور على قوائم تشغيل",
        es: "No se encontraron playlists",
        "zh-CN": "未找到播放列表",
        hi: "कोई प्लेलिस्ट नहीं मिली"
    },
    noPlaylists: {
        en: "No playlists",
        am: "ምንም ዝርዝር የለም",
        fr: "Aucune playlist",
        ar: "لا توجد قوائم تشغيل",
        es: "Sin playlists",
        "zh-CN": "没有播放列表",
        hi: "कोई प्लेलिस्ट नहीं"
    },
    selectPlaylist: {
        en: "Select Playlist",
        am: "ዝርዝር ይምረጡ",
        fr: "Sélectionner une playlist",
        ar: "اختر قائمة تشغيل",
        es: "Seleccionar playlist",
        "zh-CN": "选择播放列表",
        hi: "प्लेलिस्ट चुनें"
    },
    tryAgain: {
        en: "Try Again",
        am: "እንደገና ይሞክሩ",
        fr: "Réessayer",
        ar: "حاول مرة أخرى",
        es: "Intentar de nuevo",
        "zh-CN": "重试",
        hi: "फिर से कोशिश करें"
    },
    createFirstPlaylist: {
        en: "Create your first playlist",
        am: "የመጀመሪያዎን ዝርዝር ይፍጠሩ",
        fr: "Créez votre première playlist",
        ar: "أنشئ أول قائمة تشغيل لك",
        es: "Crea tu primera playlist",
        "zh-CN": "创建你的第一个播放列表",
        hi: "अपनी पहली प्लेलिस्ट बनाएं"
    },
    createNewPlaylist: {
        en: "Create New Playlist",
        am: "አዲስ ዝርዝር ፍጠር",
        fr: "Créer une nouvelle playlist",
        ar: "إنشاء قائمة تشغيل جديدة",
        es: "Crear nueva playlist",
        "zh-CN": "创建新播放列表",
        hi: "नई प्लेलिस्ट बनाएं"
    },
    songs: {
        en: "songs",
        am: "ዘፈኖች",
        fr: "chansons",
        ar: "أغانٍ",
        es: "canciones",
        "zh-CN": "歌曲",
        hi: "गाने"
    },
    sidebar: {
        en: "Sidebar",
        am: "የጎን ፓነል",
        fr: "Barre latérale",
        ar: "الشريط الجانبي",
        es: "Barra lateral",
        "zh-CN": "侧边栏",
        hi: "साइडबार"
    },
    Joined: {
        en: "Joined",
        am: "ተቀላቅለዋል",
        fr: "Rejoint",
        ar: "انضم",
        es: "Unido",
        "zh-CN": "已加入",
        hi: "शामिल"
    },
    open: {
        en: "Open",
        am: "ክፈት",
        fr: "Ouvrir",
        ar: "فتح",
        es: "Abrir",
        "zh-CN": "打开",
        hi: "खोलें"
    },
    selected: {
        en: "SELECTED",
        am: "ተመርጧል",
        fr: "SÉLECTIONNÉ",
        ar: "محدد",
        es: "SELECCIONADO",
        "zh-CN": "已选择",
        hi: "चयनित"
    },
    compactMode: {
        en: "Compact Mode",
        am: "ጠባብ ሁነታ",
        fr: "Mode compact",
        ar: "الوضع المضغوط",
        es: "Modo compacto",
        "zh-CN": "紧凑模式",
        hi: "कॉम्पैक्ट मोड"
    },
    suggestionLimit: {
        en: "Suggestion Limit",
        am: "የምክር ገደብ",
        fr: "Limite de suggestions",
        ar: "حد الاقتراحات",
        es: "Límite de sugerencias",
        "zh-CN": "建议上限",
        hi: "सुझाव सीमा"
    },
    minCelebrationVote: {
        en: "Min Celebration Vote",
        am: "አነስተኛ የደስታ ድምጽ",
        fr: "Vote célébration min.",
        ar: "الحد الأدنى لتصويت الاحتفال",
        es: "Voto mínimo de celebración",
        "zh-CN": "庆祝最少票数",
        hi: "न्यूनतम उत्सव वोट"
    },
    history: {
        en: "History",
        am: "ታሪክ",
        fr: "Historique",
        ar: "السجل",
        es: "Historial",
        "zh-CN": "历史记录",
        hi: "इतिहास"
    },
    noHistory: {
        en: "No history yet.",
        am: "እስካሁን ታሪክ የለም።",
        fr: "Pas encore d’historique.",
        ar: "لا يوجد سجل بعد.",
        es: "Aún no hay historial.",
        "zh-CN": "暂无历史记录。",
        hi: "अभी तक कोई इतिहास नहीं।"
    },
    loadingHistory: {
        en: "Loading history...",
        am: "ታሪክ በመጫን ላይ...",
        fr: "Chargement de l’historique...",
        ar: "جارٍ تحميل السجل...",
        es: "Cargando historial...",
        "zh-CN": "正在加载历史记录...",
        hi: "इतिहास लोड हो रहा है..."
    },
    historyLoadError: {
        en: "Unable to load history right now.",
        am: "ታሪክን አሁን መጫን አልተቻለም።",
        fr: "Impossible de charger l’historique pour le moment.",
        ar: "تعذر تحميل السجل الآن.",
        es: "No se puede cargar el historial en este momento.",
        "zh-CN": "当前无法加载历史记录。",
        hi: "अभी इतिहास लोड नहीं हो सका।"
    },
    noRecentPlaylists: {
        en: "No recent playlists",
        am: "የቅርብ ጊዜ ዝርዝሮች የሉም",
        fr: "Aucune playlist récente",
        ar: "لا توجد قوائم تشغيل حديثة",
        es: "Sin playlists recientes",
        "zh-CN": "暂无最近的播放列表",
        hi: "कोई हाल की प्लेलिस्ट नहीं"
    },
    searchResults: {
        en: "Search Results",
        am: "የፍለጋ ውጤቶች",
        fr: "Résultats de recherche",
        ar: "نتائج البحث",
        es: "Resultados de búsqueda",
        "zh-CN": "搜索结果",
        hi: "खोज परिणाम"
    },
    results: {
        en: "results",
        am: "ውጤቶች",
        fr: "résultats",
        ar: "نتائج",
        es: "resultados",
        "zh-CN": "结果",
        hi: "परिणाम"
    },
    fromHistory: {
        en: "from history",
        am: "ከታሪክ",
        fr: "depuis l’historique",
        ar: "من السجل",
        es: "del historial",
        "zh-CN": "来自历史记录",
        hi: "इतिहास से"
    },
    source: {
        en: "Source",
        am: "ምንጭ",
        fr: "Source",
        ar: "المصدر",
        es: "Fuente",
        "zh-CN": "来源",
        hi: "स्रोत"
    },
    "Added To Playlist": {
        en: "Added To Playlist",
        am: "ወደ ዝርዝር ታክሏል",
        fr: "Ajouté à la playlist",
        ar: "تمت الإضافة إلى قائمة التشغيل",
        es: "Añadido a la playlist",
        "zh-CN": "已添加到播放列表",
        hi: "प्लेलिस्ट में जोड़ा गया"
    },
    "Already In Playlist": {
        en: "Already In Playlist",
        am: "አስቀድሞ በዝርዝሩ ውስጥ አለ",
        fr: "Déjà dans la playlist",
        ar: "موجود بالفعل في قائمة التشغيل",
        es: "Ya está en la playlist",
        "zh-CN": "已在播放列表中",
        hi: "पहले से प्लेलिस्ट में है"
    },
    "Removed from suggestions": {
        en: "Removed from suggestions",
        am: "ከምክሮች ተወግዷል",
        fr: "Supprimé des suggestions",
        ar: "تمت الإزالة من الاقتراحات",
        es: "Eliminado de sugerencias",
        "zh-CN": "已从建议中移除",
        hi: "सुझावों से हटाया गया"
    },
    "Suggestions Cleared": {
        en: "Suggestions Cleared",
        am: "ምክሮች ጠፍተዋል",
        fr: "Suggestions effacées",
        ar: "تم مسح الاقتراحات",
        es: "Sugerencias borradas",
        "zh-CN": "建议已清空",
        hi: "सुझाव साफ़ किए गए"
    },
    "All suggestions removed": {
        en: "All suggestions removed",
        am: "ሁሉም ምክሮች ተወግደዋል",
        fr: "Toutes les suggestions ont été supprimées",
        ar: "تمت إزالة جميع الاقتراحات",
        es: "Se eliminaron todas las sugerencias",
        "zh-CN": "所有建议已移除",
        hi: "सभी सुझाव हटा दिए गए"
    }
};





